var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlankJersey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 58,
    viewBox: "0 0 74 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55 36.7785V25.3711",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5312 36.7785V25.3711",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7994 1H25.6712C25.4603 1 25.2508 1.03333 25.0504 1.09876L19.244 2.99442C16.1091 4.01788 13.6804 6.52106 12.752 9.68538L1.26202 48.8477C1.11437 49.3509 1.38062 49.8828 1.872 50.0661L11.209 53.5499C11.7153 53.7388 12.28 53.4913 12.4843 52.991L19.5294 35.7407V56C19.5294 56.5523 19.9771 57 20.5294 57H54C54.5523 57 55 56.5523 55 56V35.7407L62.0391 52.9763C62.2458 53.4824 62.8206 53.7287 63.3296 53.5293L72.1382 50.0784C72.6245 49.8878 72.8823 49.3551 72.7299 48.8554L60.753 9.60348C59.8017 6.48576 57.3905 4.02735 54.2918 3.01572L48.4201 1.09876C48.2197 1.03333 48.0103 1 47.7994 1Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0014 46.0001H55.0014M19.0014 50.2223H55.0014M59.7661 49.1853L70.8837 45.0371M13.7661 49.1853L2.64844 45.0371",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 3C24 3 26.4762 14.2 37 19C47.5238 14.2 50 3 50 3",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 2C28 2 30.25 10.64 37 14C43.75 10.64 46 2 46 2",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankJersey);
export default __webpack_public_path__ + "static/media/blank_jersey.779a451f30cf576040abb68a1a60f433.svg";
export { ForwardRef as ReactComponent };